import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=0b71e49c&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=ts"
export * from "./ReportList.vue?vue&type=script&lang=ts"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=0b71e49c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71e49c",
  null
  
)

export default component.exports